<template>
  <b-row>
    <Modal />
    <b-col class="col-lg-6 offset-lg-3 col-sm-12">
      <div v-if="this.$store.state.noDataFound">
        <p class="text-left lead">
          We are sorry to inform you that with the information you have entered we were not able to locate any corresponding data within our system. Please verify that you have entered your information correctly.
          <br><br>
        </p>
      </div>
      <div v-if="!this.$store.state.noDataFound && !this.$store.state.verifyLoginModal">
        <p class="text-center lead">
          Right to Know – Below is the data we found that matches your request
        </p>
        <div id="table-container">
          <div class="table-bottom-info">
            <p>1. The categories of sources from which the information was collected</p>
            <p class="bullet">Business to Consumer Marketing Site</p>
            <p>2. The business or commercial purpose for collecting the information</p>
            <p class="bullet">Marketing Purposes</p>

            <p>3. The categories of third parties with whom the business sold or disclosed the information</p>
            <p v-if="this.$store.state.isSold" class="bullet">Insurance Company</p>
            <p v-if="!this.$store.state.isSold" class="bullet">N/A</p>

            <p>4. The business or commercial purpose for selling the information</p>
            <p v-if="this.$store.state.isSold" class="bullet">Marketing Purposes</p>
            <p v-if="!this.$store.state.isSold" class="bullet">N/A</p>

            <p>5. The specific pieces of personal information the business collected about the consumer</p>
            <br>
            <b-table striped hover :items="this.$store.state.lmsDataObject"></b-table>
          </div>
        </div>
        <br><br>
        <b-button
          type="submit"
          variant="primary"
          class="btn-md"
          style="margin-right: 10px"
          v-on:click="goBack"
        >
          Go Back
        </b-button>
        <b-button
          type="submit"
          variant="primary"
          class="btn-md"
          v-on:click="savePdf"
        >
          Download as PDF
        </b-button>
      </div>
    </b-col>
  </b-row>
</template>

<script>
/* eslint-disable new-cap */
import Modal from '@/components/Modal.vue'
import { mapState } from 'vuex'
import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'
import saveAs from 'file-saver'

export default {
  created: function () {
    this.getLead()
  },
  computed: mapState([
    'showModal', 'modalText'
  ]),
  methods: {
    getLead () {
      this.$store.dispatch('getLead')
    },
    goBack () {
      this.$store.dispatch('redirectToRequestView')
    },
    savePdf () {
      this.$bvModal.msgBoxConfirm('This message is verification that by clicking the “Download” button we have (a) received your request for Portability “Right to Access and an Implied Right of Data Portability” (b) provided you with a secure method in which you are able to retrieve your data.', {
        size: 'md',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'Download',
        footerClass: 'p-2',
        hideHeaderClose: false
      }).then(value => {
        if (value === true) {
          let pdf = new jsPDF('p', 'pt', 'letter')
          let element = document.getElementById('table-container')
          let fileName = this.$store.state.pii.first_name && this.$store.state.pii.last_name ? this.$store.state.pii.first_name + '-' + this.$store.state.pii.last_name + '-info' : 'my-info'
          window.html2canvas = html2canvas
          pdf.fromHTML(element)

          // Adding mobile support.
          if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            let dc = pdf.output('datauristring')
            saveAs(dc, fileName + '.pdf')
          } else {
            pdf.save(fileName + '.pdf')
          }
        } else {
          // Do nothing
        }
      }).catch(err => {
        console.log('error: ', err) // Need to display an error message.
        return false
      })
    }
  },
  components: {
    Modal
  }
}
</script>
<style lang="less">
  #lmsData {
    min-height: 700px;
    font-family: "Lucida Console", Monaco, monospace;
    font-size: 0.8rem;
    line-height: 1.6;
  }
  #table-container {
    background: #FFF;
    padding: 0;
    border-radius: 10px;
    -webkit-box-shadow: 0 0 54px 6px rgba(217, 217, 217, 0.54);
    box-shadow: 0 0 33px 6px rgb(234, 234, 234);
    .table {
      td {}
      th {}
    }
    .table-bottom-info {
      padding: 20px 10px;
      font-size: 14px;
      p {
        margin: 0 0 5px 0;
        padding: 0 20px;
        text-align: left;
        &.bullet:before {
          content: '• ';
          margin-left: 20px;
        }
      }

      ol {}
    }
  }

</style>
